import * as React from 'react';
import { AlarmsFilters } from '../../../app/manage-alarms/AlarmsFilters';
import { FiltersData } from '../../../types';
import { useState } from 'react';
import { ManageAlarmsFilters } from '../../../app/manage-alarms/ManageAlarmsFilters';
import { DeviceChannelCountProvider } from '../../../data/DataProviders/DeviceChannelCountProvider';
import { EmptyState } from '@brightlayer-ui/react-components';
import { Info } from '@mui/icons-material';
import { Box } from '@mui/material';
// import { useLanguageLocale } from '../../../hooks/language-locale-hooks';

export const SingleAlarm: React.FC<{ index: number; value: number }> = (props) => {
    // const { t } = useLanguageLocale();
    const [filtersData, setFiltersData] = useState<FiltersData | null>(null);
    // const [deviceList, setDeviceList] = useState<any[]>([]);
    // const siteDeviceData = useSiteDevicesData();
    // const { t } = useLanguageLocale();
    //  const [device, setDevice] = useState('');

    // useEffect(() => {
    //     if (isDataLoaded(siteDeviceData)) {
    //         setDeviceList(siteDeviceData.value);
    //     }
    // }, [siteDeviceData]); // eslint-disable-line react-hooks/exhaustive-deps

    const deviceChannelData = (data: FiltersData): void => {
        setFiltersData(data);
    };

    const { value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <AlarmsFilters value={props.value} deviceChannelData={deviceChannelData}></AlarmsFilters>
            {filtersData && (
                <>
                    {/* <Box
                        style={{ marginRight: 50, marginLeft: 50, marginTop: 20, marginBottom: 20 }}
                        display={'flex'}
                        justifyContent="flex-start"
                    >
                        <Typography style={{ width: 150, lineHeight: 3.5 }} variant={'subtitle1'}>
                            {t('MANAGEALARMS.DEVICE')}
                        </Typography>
                        <Autocomplete
                            freeSolo
                            id="free-solo-2-demo"
                            style={{ width: '100%', background: '#fff' }}
                            disableClearable
                            options={deviceList.map((option) => option.name)}
                            onChange={(event, val): void => {
                                setDevice(val);
                            }}
                            renderInput={(params): JSX.Element => (
                                <TextField
                                    {...params}
                                    label="Search Device Name"
                                    InputProps={{
                                        ...params.InputProps,
                                        type: 'search',
                                    }}
                                />
                            )}
                        />
                    </Box> */}
                    <DeviceChannelCountProvider
                        siteId={filtersData.siteId}
                        gatewayId={filtersData.gatewayId}
                        deviceType={filtersData.deviceType}
                    >
                        <ManageAlarmsFilters></ManageAlarmsFilters>
                    </DeviceChannelCountProvider>
                </>
            )}
            {!filtersData && (
                <Box style={{ padding: 8, display: 'flex', justifyContent: 'center' }}>
                    <EmptyState
                        title="No devices found for the selected filters"
                        icon={
                            <div style={{ fontSize: 48 }}>
                                <Info />
                            </div>
                        }
                    />
                </Box>
            )}
        </div>
    );
};
